import { render, staticRenderFns } from "./DiskSpace.vue?vue&type=template&id=09dcd3bc"
import script from "./DiskSpace.vue?vue&type=script&lang=js"
export * from "./DiskSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports